import React from "react";

export default function DeleteAccount() {
  return (
    <div className="min-h-screen bg-[#0b0b0b] text-[#e8e8e8]">
      <main className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="text-4xl font-bold text-white mb-3">
          RayFuel Account Deletion
        </h1>

        <p className="text-gray-400 mb-8">
          RayFuel is operated by RAYBOTIX AER.
        </p>

        <h2 className="text-2xl font-semibold text-white mt-8 mb-3">
          Request account deletion
        </h2>

        <p>
          You can request deletion of your RayFuel account and associated
          personal data by emailing:
        </p>

        <p className="my-4">
          <a
            href="mailto:smm.raybotix@gmail.com?subject=RayFuel%20Account%20Deletion%20Request"
            className="text-[#FF5A1F] underline"
          >
            smm.raybotix@gmail.com
          </a>
        </p>

        <p>Please include:</p>

        <ul className="list-disc pl-6 mt-3 space-y-2">
          <li>The email address registered with your RayFuel account.</li>
          <li>A request stating that you want your RayFuel account deleted.</li>
        </ul>

        <p className="mt-4">
          We may verify that the request belongs to the account owner before
          processing deletion.
        </p>

        <h2 className="text-2xl font-semibold text-white mt-8 mb-3">
          Data that will be deleted
        </h2>

        <ul className="list-disc pl-6 space-y-2">
          <li>RayFuel account profile information.</li>
          <li>Vehicle and fleet information associated with the account.</li>
          <li>Fuel, mileage, maintenance and service records.</li>
          <li>User-uploaded documents and other account-associated content.</li>
          <li>Other personal information no longer required to provide the service.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-white mt-8 mb-3">
          Data that may be retained
        </h2>

        <p>
          Certain transaction, accounting, security, fraud-prevention or legal
          records may be retained where required by applicable law or legitimate
          compliance obligations. Such records are retained only for the period
          required for those purposes.
        </p>

        <h2 className="text-2xl font-semibold text-white mt-8 mb-3">
          Subscriptions
        </h2>

        <p>
          Account deletion does not automatically cancel subscriptions managed
          by an external payment or app-store provider. If applicable, cancel
          any active subscription separately through the provider used for the
          purchase.
        </p>

        <h2 className="text-2xl font-semibold text-white mt-8 mb-3">
          Contact
        </h2>

        <p>
          RAYBOTIX AER / RayFuel<br />
          Email: smm.raybotix@gmail.com
        </p>
      </main>
    </div>
  );
}
